import script from "./PackingListConfig.vue?vue&type=script&lang=ts&setup=true"
export * from "./PackingListConfig.vue?vue&type=script&lang=ts&setup=true"

import "./PackingListConfig.vue?vue&type=style&index=0&id=592d102d&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-592d102d"]])

export default __exports__